import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useMatch, useParams } from "react-router-dom";
import { DashboardPageLayout } from "../../layout/dashboard";
import InvoicesPage from "./InvoicesPage";
import SubscriptionTab from "./Subscription";
import { Box, Typography } from "@mui/material";

function SubscriptionPage() {
	const { t } = useTranslation();
	const isChanging = useMatch("/account/subscription/change/:id");
	const isPurchasing = useMatch("/account/subscription/purchase");

	if (isChanging || isPurchasing) {
		return (
			<>
				<Outlet />
			</>
		);
	}

	return (
		<>
			<DashboardPageLayout
				pageName={t("subscriptionPage.pageName")}
				childTabs={[
					{ label: t("subscriptionPage.subscriptionTab"), tabRoute: "subscriptionTab" },
					{ label: t("subscriptionPage.invoicesTab"), tabRoute: "invoiceTab" },
				]}
				defaultTab="subscriptionTab"
				maxWidth={"none"}
			>
				<Outlet />
				<Typography maxWidth={600} textAlign={"center"} mx={"auto"} mt={8}>
					{t("support.IfYouHaveIssues")}
				</Typography>
			</DashboardPageLayout>
		</>
	);
}

export function SubscriptionPageTabs() {
	const { tabRoute } = useParams();

	const currentTab = useMemo(() => {
		return tabRoute ? tabRoute : "subscriptionTab";
	}, [tabRoute]);

	return (
		<>
			{currentTab === "subscriptionTab" && <SubscriptionTab />}
			{currentTab === "invoiceTab" && <InvoicesPage />}
		</>
	);
}

export default SubscriptionPage;
